<template>
	<el-card v-show="symptoms.length > 0">
		<div slot="header" class="symptom header">
			<img src="../image/symptom_new.png" class="header-icon">
			<span class="header-title">Symptoms</span>
			<!-- <el-button icon="el-icon-right" circle type="text" size="large"></el-button> -->
		</div>
		<SymptomTable
			:patient="patient"
			v-bind:symptoms="symptoms"
			:descending="true">
		</SymptomTable>
	</el-card>
</template>

<script>
import OverviewCard from '..'
import SymptomTable from './Table'

export default {
	name: 'patient-symptom-card',
	extends: OverviewCard,

	computed: {
		symptoms() {
			return this.patientEventType('symptom')
		}
	},

	components: {
		SymptomTable
	}
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
@import "./style.scss";
</style>
